import React, {Component} from "react"
import {injectIntl} from "react-intl"
import {connect} from "react-redux"
import {
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Tab,
  Tabs, ButtonGroup, Radio
} from "react-bootstrap"
import CustomButton from "../../../../components/Button"

import {queryUserInfoById, getUserScheduleById, createScheduleForUser} from "../../../../dispatch"
import {
  ACTION_QUERY_COUNTRY_LIST_LOADING,
  ACTION_QUERY_EDUCATION_LIST_LOADING,
  COGO_TRAINING_NO_OF_CYCLES_PER_SESSION,
  COLOR_NAVY,
  EVENT_COGOLAND_SESSION_RESCEDULED,
  EVENT_OPEN_ACCOUNT_SELECTION_MODAL
} from "../../../../constants"
import UserImage from "../../../../components/UserImage"
import UserInfoTable from "../../../../components/UserInfoTable"
import CogoLandSessionsTable from "../../../cogoland/component/CogoLandSessionsTable"
import CreateScheduleForm from "../../../cogoland/component/CreateScheduleForm"
import ComponentWrapper from "../../../../components/ComponentWrapper"
import CogolandSessionDetails from "./CogolandSessionDetails"
import CogolandOverallProgressChart from "./CogolandOverallProgressChart"
import IBox from "../../../../components/IBox"
import CogolandSessionTable from "./CogolandSessionTable"
import {RxEmitter} from "rxemitter"
import DownloadReportButton from "../../components/DownloadReportButton"
import {RadioGroup} from "formsy-react-components"
import Form from "../../../../components/form/Form"

function mapStateToProps(state, ownProps) {

  const user = state.user
  const locale = state.locale
  const schedule = state.schedule
  const selectedUser = state.selectedUser

  return {
    user,
    locale,
    schedule,
    selectedUser,
  }
}

const mapDispatchToProps = {
  queryUserInfoById,
  getUserScheduleById,
  createScheduleForUser,
  queryEducations: function () {
    return {
      type: ACTION_QUERY_EDUCATION_LIST_LOADING
    }
  },
  queryCountries: function () {
    return {
      type: ACTION_QUERY_COUNTRY_LIST_LOADING
    }
  }
}

const fontSizeH = '15px'
const fontSizeP = '13px'


class UserProfileModal extends Component {

  constructor() {
    super()
    this.state = {currentPage:1}
  }

  componentWillMount() {

    const component = this

    RxEmitter.on(EVENT_COGOLAND_SESSION_RESCEDULED).subscribe((x) => {
      const userId = component.props.userId
      console.log('on EVENT_COGOLAND_SESSION_RESCEDULED')
      this.props.getUserScheduleById(userId)
    });
  }


  componentWillReceiveProps(nextProps) {
    const userId = nextProps.userId
    if (userId !== this.props.userId) {
      this.props.queryUserInfoById(userId)
      this.props.getUserScheduleById(userId)

    }
  }

  render() {


    const selectedUser = this.props.selectedUser
    const format = this.props.intl.formatMessage

    const schedule = op.get(this.props.schedule, 'schedule', {})
    const sessions = _.sortBy(op.get(this.props.schedule, 'sessions', []), 'index')

    const cycleList = _.chunk(sessions, COGO_TRAINING_NO_OF_CYCLES_PER_SESSION)

    const currentPage = this.state.currentPage

    const cycle1Index = cycleList.length > 1?currentPage:1
    const cycle2Index = cycleList.length > 1?currentPage + 1:undefined

    const cycle1 = cycleList[cycle1Index - 1]
    const cycle2 = cycle2Index?cycleList[cycle2Index - 1]:[]

    const indexList = _.range(1, cycleList.length === 1?2:cycleList.length)

    const downloadReportButton = (<ButtonToolbar>
      <ButtonGroup className="m-r-lg" title={format({id:"download.report"})}>
        {indexList.map(index=>(<DownloadReportButton style="default" userId={selectedUser.id} extraParams={{index:index}}/>))}
      </ButtonGroup>
    </ButtonToolbar>)
    const reportButtonGroup = (
      <ButtonToolbar>
        <DropdownButton
          className="m-r-lg"
          title={format({id:"preview.report"})}>
          {indexList.map(index=>(<MenuItem onSelect={() => {
            const url = `/enterprise/cogoland/users/report/${selectedUser.id}?index=${index}`
            window.open(url, '_blank')
          }}>
            {format({id:"html.report"})} {index}
          </MenuItem>))}

        </DropdownButton>
      </ButtonToolbar>
    )



    const userInfoComponent = selectedUser.id ?
      <div className="row">

        <div className="col-lg-12 text-center p-h-xs">
          <div style={{fontSize:fontSizeH, fontWeight:"bold", fontFamily:'Roboto, Medium'}}>{format({id:'cogoland.user.profile.title'})}</div>
        </div>

        <div className="col-lg-12 p-h-xs">

          <div className="row m-l-md">
            <UserInfoTable user={selectedUser}/>
          </div>

          {schedule.id?(<div className="row m-l-xs">
            <div className="col-xs-6 p-sm">
            </div>
            <div className="col-xs-3 text-center">
              <div className="m-t-md">
              {downloadReportButton}
              </div>
            </div>
            <div className="col-xs-3 text-center">
              <div className="m-t-md">
                {reportButtonGroup}
              </div>
            </div>
          </div>):''}


        </div>
      </div>
      :
      ""

    const createScheduleFormData = this.state.createScheduleFormData

    const buildSessionDetails = session => (
      <div>
        <div className="text-right">
          <CustomButton
            style="default"
            className="m-b-sm"
            onClick={() => {
              this.setState({selectedSession: undefined})
            }}>
            {format({id:'back'})}
          </CustomButton>
        </div>
        <CogolandSessionDetails session={session}/>
      </div>
    )
    const latestCycle = cycle2?cycle2:cycle1
    const latestCycleIndex = cycle2Index?cycle2Index:cycle1Index

    const scheduleTable = <ComponentWrapper loading={this.props.schedule.loading}>

      {schedule.id ? (
        <Tabs defaultActiveKey={1}>
          <Tab eventKey={1} title={format({id:'cogoland.tab.sessions'})}>
            <CogoLandSessionsTable
              onSelect={(session) => {
                this.setState({selectedSession: session})
              }}
              data={_.sortBy(sessions, 'index')}/>

          </Tab>
          <Tab eventKey={2} title={format({id: 'cogoland.tab.overall.progress'})}>
            <div className={'row m-t-md'}>
              <div className={'col-xs-12 text-left'}>
                <Form>
                  <RadioGroup
                    name={"page"}
                    type={"inline"}
                    label={""}
                    onChange={(name, value)=>{
                      this.setState({currentPage: _.toNumber(value)})
                    }}
                    value={this.state.currentPage}
                    options={_.range(1, cycleList.length).map(n=>({value:n, label:`${format({id:'cycle'})} ${n}-${n+1}`}))}
                  />
                </Form>
              </div>
            </div>
            <IBox title={""}>
              <CogolandOverallProgressChart cycle1Sessions={cycle1} cycle2Sessions={cycle2} cycle1Index={cycle1Index}
                                            cycle2Index={cycle2Index}/>
            </IBox>

            <div className={"col-xs-12"}>
              <h4 style={{
                fontFamily: 'Roboto, Bold',
                fontSize: fontSizeH,
                fontWeight: "bold",
                color: COLOR_NAVY
              }}>{format({id: 'cycle'})} {cycle1Index}</h4>
              <CogolandSessionTable data={cycle1} name={'cycle1'}/>

              <h4 style={{
                fontFamily: 'Roboto, Bold',
                fontSize: fontSizeH,
                fontWeight: "bold",
                color: COLOR_NAVY
              }}>{format({id: 'cycle'})} {cycle2Index}</h4>
              <CogolandSessionTable data={cycle2} name={'cycle2'}/>
            </div>


          </Tab>


        </Tabs>
      ) : (
        <div>
          <IBox>
            <h4>{format({id: 'training.schedule.setup'})}</h4>
            <p>
              {format({id: "cogoland.schedule.form.desc1"})}<br/>
              {format({id: "cogoland.schedule.form.desc2"})}<br/>
            </p>
            <h4>{format({id: 'schedule.selection'})}</h4>
            <CreateScheduleForm onChange={(data) => {
              this.setState({createScheduleFormData: data})
            }}/>
          </IBox>
        </div>
      )}

    </ComponentWrapper>

    return (
      <Modal bsSize="large"
             onEnter={() => {
               this.setState({selectedSession: undefined})
             }}
             show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton style={{paddingBottom: 0}}>
          {userInfoComponent}
        </Modal.Header>
        <ModalBody className={this.state.selectedSession ? "gray-bg" : "white-bg"}>

          {this.state.selectedSession ?
            buildSessionDetails(this.state.selectedSession)
            : scheduleTable}

        </ModalBody>
        <ModalFooter>
          {schedule.id ? '' :
            (
              <CustomButton
                disabled={!(createScheduleFormData && createScheduleFormData.startDate && createScheduleFormData.schedulableDayOfWeek)}
                onClick={() => {
                  const {startDate, schedulableDayOfWeek} = this.state.createScheduleFormData
                  this.props.createScheduleForUser(this.props.userId, startDate, schedulableDayOfWeek)
                }}>
                {format({id:"save.schedule"})}
              </CustomButton>
            )

          }
          <Button onClick={this.props.onHide}>
            {format({id: 'close'})}
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(UserProfileModal))



// WEBPACK FOOTER //
// ./src/routes/enterprise/dashboard/components/UserProfileModal.js